// src/store/modules/szamlazzhu.js
import ApiService from "@/core/services/api.service";

const initialState = () => ({
  loading: false,
  error: null,

  documents: [],
  document: null,

  invoice: null,
  proforma: null,
  finalInvoice: null,

  pdfUrl: null,
  lastResponse: null,
});

const state = initialState();

const getters = {
  szamlazzhuLoading: (state) => state.loading,
  szamlazzhuError: (state) => state.error,

  szamlazzhuDocuments: (state) => state.documents,
  szamlazzhuDocument: (state) => state.document,

  szamlazzhuInvoice: (state) => state.invoice,
  szamlazzhuProforma: (state) => state.proforma,
  szamlazzhuFinalInvoice: (state) => state.finalInvoice,

  szamlazzhuPdfUrl: (state) => state.pdfUrl,
  szamlazzhuLastResponse: (state) => state.lastResponse,
};

const mutations = {
  SET_LOADING(state, value) {
    state.loading = value;
  },

  SET_ERROR(state, value) {
    state.error = value;
  },

  SET_DOCUMENTS(state, value) {
    state.documents = Array.isArray(value) ? value : [];
  },

  SET_DOCUMENT(state, value) {
    state.document = value || null;
  },

  SET_INVOICE(state, value) {
    state.invoice = value || null;
  },

  SET_PROFORMA(state, value) {
    state.proforma = value || null;
  },

  SET_FINAL_INVOICE(state, value) {
    state.finalInvoice = value || null;
  },

  SET_PDF_URL(state, value) {
    state.pdfUrl = value || null;
  },

  SET_LAST_RESPONSE(state, value) {
    state.lastResponse = value || null;
  },

  RESET_STATE(state) {
    Object.assign(state, initialState());
  },
};

const actions = {
  async fetchDocumentsBySalesOrder({ commit }, salesOrderId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.get(
        "szamlazzhu/sales-order-documents",
        salesOrderId
      );

      commit("SET_DOCUMENTS", response?.data?.data || response?.data || []);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async fetchDocument({ commit }, documentId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.get("szamlazzhu/documents", documentId);

      commit("SET_DOCUMENT", response?.data?.data || response?.data || null);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  /*async createProforma({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.post(
        "szamlazzhu/create-proforma",
        payload
      );

      commit("SET_PROFORMA", response?.data?.data || response?.data || null);
      commit("SET_PDF_URL", response?.data?.pdf_url || null);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async createInvoice({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.post(
        "szamlazzhu/create-invoice",
        payload
      );

      commit("SET_INVOICE", response?.data?.data || response?.data || null);
      commit("SET_PDF_URL", response?.data?.pdf_url || null);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async createFinalInvoice({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.post(
        "szamlazzhu/create-final-invoice",
        payload
      );

      commit("SET_FINAL_INVOICE", response?.data?.data || response?.data || null);
      commit("SET_PDF_URL", response?.data?.pdf_url || null);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },*/

  async downloadPdf({ commit }, documentId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.get(
        "szamlazzhu/download-pdf",
        documentId
      );

      commit("SET_PDF_URL", response?.data?.pdf_url || null);
      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async sendEmail({ commit }, payload) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    try {
      const response = await ApiService.post(
        "szamlazzhu/send-email",
        payload
      );

      commit("SET_LAST_RESPONSE", response?.data || null);

      return response;
    } catch (error) {
      commit("SET_ERROR", error?.response?.data || error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  resetSzamlazzhuState({ commit }) {
    commit("RESET_STATE");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};